  const wrapText = (ctx, text, x, y, maxWidth, lineHeight) => {
  const words = text.split(" ");
  let line = "";
  let lines = [];

  for (let n = 0; n < words.length; n++) {
    const testLine = line + words[n] + " ";
    const metrics = ctx.measureText(testLine);
    const testWidth = metrics.width;

    if (testWidth > maxWidth && n > 0) {
      lines.push(line);
      line = words[n] + " ";
    } else {
      line = testLine;
    }
  }

  lines.push(line);

  lines.forEach((l, i) => {
    ctx.fillText(l.trim(), x, y + i * lineHeight);
  });

  return lines.length; 
};
const generateCustomImage = async ( results,
  res_stud_data,
  res_reg_no,
  res_dept,
  Gpa,
  Cgpa,) => {
  try {
    console.log("generateCustomImage called");
console.log(results);
    const padding = 40;
    const rowHeight = 50;
    const headerHeight = 180;

    const columns = ["Subject Code", "Subject Name", "Grade", "Result"];

    const colWidths = [200, 400, 150, 150];
    const totalWidth = colWidths.reduce((a, b) => a + b, 0) + padding * 2;

    const totalHeight =
      headerHeight +
      rowHeight * (results.length + 1) +
      padding * 2;

    
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = totalWidth;
    canvas.height = totalHeight;

    
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

   
    ctx.fillStyle = "#00134d";
    ctx.font = "bold 28px Arial";

    ctx.fillText("Result", padding, 50);

    ctx.font = "20px Arial";

    ctx.fillText(`Name: ${res_stud_data.studentname}`, padding, 90);
    ctx.fillText(`Register No: ${res_reg_no}`, padding, 120);
    ctx.fillText(`Department: ${res_dept}`, padding, 150);

    // ctx.fillText(`GPA: ${Gpa}`, totalWidth - 300, 90);
    // ctx.fillText(`CGPA: ${Cgpa}`, totalWidth - 300, 120);

    
    let y = headerHeight;

    ctx.fillStyle = "#00134d";
    ctx.fillRect(padding, y, totalWidth - padding * 2, rowHeight);

    ctx.fillStyle = "#ffffff";
    ctx.font = "bold 18px Arial";

    let x = padding;

    columns.forEach((col, i) => {
      ctx.fillText(col, x + 10, y + 30);
      x += colWidths[i];
    });

    y += rowHeight;

    
    ctx.font = "16px Arial";

    results.forEach((row, index) => {
      ctx.fillStyle = index % 2 === 0 ? "#d9edff" : "#f1f1f1";
      ctx.fillRect(padding, y, totalWidth - padding * 2, rowHeight);

      ctx.fillStyle = "#00134d";

      let x = padding;

      const values = [
        row.subcode,
        row.subjectname,
        row.grade,
        row.result,
      ];

      let maxLines = 1;

values.forEach((val, i) => {
  if (i === 1) {
    // SUBJECT NAME COLUMN (wrap text)
    const lines = wrapText(
      ctx,
      String(val),
      x + 10,
      y + 20,
      colWidths[i] - 20,
      18
    );

    maxLines = Math.max(maxLines, lines);
  } else {
    ctx.fillText(String(val), x + 10, y + 30);
  }

  x += colWidths[i];
});

      y += Math.max(rowHeight, maxLines * 22);
    });

    
    const dataUrl = canvas.toDataURL("image/png");

    const res = await fetch(dataUrl);
    const blob = await res.blob();

    const file = new File([blob], "result.png", {
      type: "image/png",
    });

    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({
        files: [file],
        title: "Result",
      });
    } else {
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "result.png";
      link.click();
    }

  } catch (err) {
    console.error("Canvas image failed:", err);
  }
};
export default generateCustomImage;